<template>
  <div class="d-flex flex-column">
    <v-row dense>
      <v-col cols="11" class="d-flex">
        <v-row dense>
          <v-col
            v-for="(col, i) in headers"
            :key="i"
            :cols="col.size !== undefined ? col.size : 1"
            :class="col.class"
          >
            {{ col.text }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-for="(item, i) in items" :key="item.id">
      <v-row no-gutters dense>
        <v-col cols="11">
          <TcnVJsfWrapper
            v-model="item.model"
            :schema="item.schema"
            :options="options"
            @input="updateModel($event, i)"
          />
        </v-col>
        <v-col cols="1">
          <v-btn
            v-if="$vuetify.breakpoint.xlOnly"
            style="max-width: 100%"
            :color="deleteIconColor"
            tile
            @click="removeRow(item, i)"
            text
          >
            <v-icon left :color="deleteIconColor" :size="iconSize">
              {{ deleteIcon }}
            </v-icon>
            <div style="text-transform: none !important">
              {{ deleteText }}
            </div>
          </v-btn>
          <v-btn text v-if="$vuetify.breakpoint.lgAndDown">
            <v-icon
              left
              :color="deleteIconColor"
              :size="iconSize"
              @click="removeRow(item, i)"
            >
              {{ deleteIcon }}
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-divider class="mb-5" />
    </div>

    <div>
      <v-btn :color="addIconColor" class="my-2" tile @click="addNewRow" text>
        <v-icon left :color="addIconColor" :size="iconSize">
          {{ addIcon }}
        </v-icon>
        <div style="text-transform: none !important">
          {{ addText }}
        </div>
      </v-btn>
    </div>
  </div>
</template>
<script>
import { v4 as uuidv4 } from "uuid";

export default {
  name: "TcnPozycjaFaktury",
  components: {},
  props: {
    value: { type: Array, default: null },
    options: { type: Object, required: true },
    schema: { type: Object, required: true },
    fullSchema: { type: Object, required: true },
    fullKey: { type: String, required: true },
    label: { type: String, default: "" },
    htmlDescription: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    rules: { type: Array, required: true },
    on: { type: Object, required: true },
  },
  data() {
    return {
      localSchema: {},
      items: [],
    };
  },
  computed: {
    addIconColor() {
      return this.fullSchema["items"]["addIconColor"] || "";
    },

    deleteIconColor() {
      return this.fullSchema["items"]["deleteIconColor"] || "";
    },

    addIcon() {
      return "mdi-plus-box";
    },

    addText() {
      return this.fullSchema["items"]["addBtnText"] || "";
    },

    deleteIcon() {
      return "mdi-minus-box";
    },

    deleteText() {
      return this.fullSchema["items"]["deleteBtnText"] || "";
    },

    iconSize() {
      return this.fullSchema["items"]["iconSize"] || 22;
    },

    headers() {
      let arr = Object.keys(this.fullSchema.items.properties);
      let arrCols = arr.map(
        (item) => this.fullSchema.items.properties[item]["x-cols"]
      );
      let arrClass = arr.map(
        (item) => this.fullSchema.items.properties[item]["x-class"]
      );
      return this.fullSchema.items.headers.map((item, i) => {
        return { text: item, size: arrCols[i], class: arrClass[i] };
      });
    },
  },
  watch: {},
  methods: {
    updateModel(item, index) {
      console.log("TcnPozycjaFaktury updateModel");
      this.$emit("updateArrElement", {
        key: this.fullKey,
        value: { index: index, item: item },
      });
    },

    removeRow(itemToDelete, index) {
      this.items = this.items.filter((item) => item !== itemToDelete);
      let obj = { index: index };
      this.$emit("updateArrElement", { key: this.fullKey, value: obj });
    },

    addNewRow() {
      this.items.push({
        schema: this.localSchema,
        model: {},
      });
      this.$emit("updateArrElement", {
        key: this.fullKey,
        value: {
          index: this.items.length - 1,
          item: this.items[this.items.length - 1].model,
        },
      });
    },
    init() {
      this.localSchema = this.fullSchema["items"];
      if (this.value instanceof Array) {
        this.value.forEach((item) => {
          this.items.push({
            schema: this.localSchema,
            model: item,
            id: uuidv4(),
          });
        });
      } else {
        let obj = {};
        this.value.push(obj);
        this.items.push({
          schema: this.localSchema,
          model: obj,
          id: uuidv4(),
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang="css"></style>
